module.exports = __webpack_public_path__ + "img/votacionesx3.eb341b85.jpg";